// List of supported audio file extensions
const supportedAudioFileTypes = [
  '.mp3',
  '.wav',
  '.m4a',
  '.ogg',
  '.webm',
  '.mov',
  '.mp4'
];

export { supportedAudioFileTypes }; 